import type {
  DataAnalyticsErrorReport,
  DataAnalyticsSuccessReport,
  DataMetricErrorReport,
  DataMetricSuccessReport,
  DataSentryErrorReport,
} from 'src/internal/revamp/telemetry/types';
import type {ObservabilityFns} from 'src/internal/shared/observability/types';

export function logHttpError(
  type: 'GraphQL' | 'Fetch',
  observabilityFns: ObservabilityFns,
  params: DataAnalyticsErrorReport,
): void {
  const {analytics, errors, metrics} = observabilityFns || {};

  analytics.track('frontend.data.error', params);

  const metricTags: DataMetricErrorReport = {
    service: params.service,
    project: params.project,
    component: params.component,
    error_expected: params.error_expected,
    operation_name: params.operation_name,
  };

  metrics.increment('frontend.data.error', metricTags);

  if (params.error_expected || params.project === '<unknown>') {
    return;
  }

  const sentryParams: DataSentryErrorReport = {
    service: params.service,
    project: params.project,
    component: params.component,
    errorCode: params.error_code,
    errorMessage: params.error_message,
    errorExpected: params.error_expected,
    errorPath: params.error_path,
    operationName: params.operation_name,
    networkDuration: params.network_duration,
    networkStart: params.network_start,
    networkEnd: params.network_end,
    networkStatus: params.network_status,
    networkActionId: params.network_action_id,
    networkRequestId: params.network_request_id,
    networkTraceId: params.network_trace_id,
    loadId: params.load_id,
  };

  const project = params.project;
  const errorCode = params.error_code;
  const operationName = params.operation_name;

  const errorMessage = `${type} error '${errorCode}' on operation '${operationName}'`;

  errors.error(errorMessage, {
    project,
    extras: sentryParams,
  });
}

export function logHttpSuccess(
  type: 'GraphQL' | 'Fetch',
  observabilityFns: ObservabilityFns,
  params: DataAnalyticsSuccessReport,
): void {
  const {analytics, metrics} = observabilityFns || {};

  analytics.track('frontend.data.success', params);

  const metricTags: DataMetricSuccessReport = {
    service: params.service,
    project: params.project,
    component: params.component,
    operation_name: params.operation_name,
  };

  metrics.increment('frontend.data.success', metricTags);
}
